<template>
  <div class="box grow flex" @click="$emit('click')">
    <div class="box grow flex column justify-center p-10 info">
        <span style="margin-bottom:10px;">{{customerName(customer)}}</span>
        <span class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;">{{inv_number}} <span v-if="reference"> ({{reference}})</span></span>
        <span class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;" v-if="date">{{moment(date)}}</span>

    </div>
    <div class="overdue flex p-10" style="flex-direction:column">
      <span class="" style="text-align:right;">{{$n(total,'currency',currency.code)}}</span>
      <span class="fs-14 secondary-text" style="text-align:right;">{{$t("invoices.statuses."+status.code)}}</span>
      <span class="fr-14 secondary-text" style="text-align:right;" >
        <InvoiceNoticeStatus :notice_status="notice_status"></InvoiceNoticeStatus>
        <i v-if="files.length>0" class="el-icon-paperclip"></i>
      </span>
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import InvoiceNoticeStatus from '@/components/invoice/invoice-notice-status'

export default {
  name: 'Invoice-tile',
	props: {
    customer : {
      type : Object,
      require : true
    },
    inv_number : {
      type : String,
      require : true
    },
    reference : {
      type : String
    },
    date : {
      type : String
    },
    total : {
      type : Number
    },
    status : {
      type : Object,
      require : true
    },
    files : {
      type : Array
    },
    currency : {
      type : Object,
      require : true
    },
    sent : {
      type : Boolean,
      require : true
    },
    notice_status : {
      type : Object,
      require : true
    }
	},
  data() {
    return {
    };
  },components: {
    InvoiceNoticeStatus
  },
	methods: {
    moment(datetime){
      return  moment(datetime).format('LL');
    }
	},
	computed: {
    noticeStatusText(){
      return this.$i18n.t('invoices.notice_statuses.' + this.notice_status.code);
    },
    noticeClass(){
      let styleClass="primary-text";
      if(this.notice_status==null){
        styleClass = "secondary-text"
      }else if(this.notice_status.code=='SENT'){
        styleClass = "warning-text"
      }else if(this.notice_status.code=='DELIVERED'){
        styleClass = "accent-text"
      }else if(this.notice_status.code=='OPENED'){
        styleClass = "success-text"
      }else if(this.notice_status.code=='BOUNCED'){
        styleClass = "danger-text"
      }else if(this.notice_status.code=='HARD_BOUNCED'){
        styleClass = "danger-text"
      }
      return styleClass;
    },
    ...mapGetters('invoices',['customerName'])
	}
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';



</style>
